import { EQUIPMENT_TYPES } from "constants/signup";
import { ILocations } from "models/Load";

export const loadInfo = (trailerType: string, length: number, weight: number) =>
  `${
    trailerType !== "" ? EQUIPMENT_TYPES.find(({ value }) => value === trailerType)?.label : "Any"
  } / ${length} ft / ${weight} lbs`;

export const locationInfo = (locations: ILocations[] | string) => {
  let name;
  let suffix;

  const locationsArr: ILocations[] =
    typeof locations === "string" ? JSON.parse(locations) : locations;

  if (locationsArr) {
    name = locationsArr[0].name ? `${locationsArr[0].name}: ` : "";
    suffix = locationsArr?.length > 1 ? `(+${locationsArr.length})` : "";
  }

  return {
    name: name,
    suffix: suffix
  };
};
